import $$ from 'cmn-utils'

const baseUrl = "/api/sys/telecom/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },

}